var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-2"},[_c('router-view',{attrs:{"todo":_vm.selectedTodo},on:{"onTodoChanged":_vm.onTodoChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }